export enum DefaultPort {
  HTTP = 80,
  HTTPS = 443,
}
